module.exports = __webpack_public_path__ + "media/B_leaves_transition.ba83b628.mp3";